import axios, { getData } from 'lib/axios'
import { useMutation, useQuery, useQueryClient } from 'react-query'

export const useGetAllLeaveRequest = (query = {}) => {
  const { limit, page } = query
  return useQuery('leave-request', async () => {
    if (Object.keys(query).length !== 0 && query.constructor === Object) {
      const res = await axios.get(`/leave-request?limit=${limit}&page=${page}`).then(getData)
      return res.data
    } else {
      const res = await axios.get(`/leave-request`).then(getData)
      return res.data
    }
  })
}

export const useGetAllFilteredLeaveRequest = (query = {}) => {
  const { limit, status, page } = query
  let queryString = ''
  if (status) {
    queryString = `/leave-request?status=${status}&limit=${limit}&page=${page}`
  } else {
    queryString = `/leave-request?&limit=${limit}&page=${page}`
  }

  return useQuery(['leave-request', { status: status }], async () => {
    if (Object.keys(query).length !== 0 && query.constructor === Object) {
      const res = await axios.get(queryString).then(getData)
      return res.data
    } else {
      const res = await axios.get(`/leave-request`).then(getData)
      return res.data
    }
  })
}

export const useGetAllLeaveCreditRequest = (query = {}) => {
  const { limit, type, page } = query
  return useQuery(['leave-request', { type: type }], async () => {
    if (Object.keys(query).length !== 0 && query.constructor === Object) {
      const res = await axios
        .get(`/leave-request?limit=${limit}&type=${type}&page=${page}`)
        .then(getData)
      return res.data
    } else {
      const res = await axios.get(`/leave-request`).then(getData)
      return res.data
    }
  })
}

export const useShowLeaveRequest = (id) =>
  useQuery(['leave-request', id], async () => {
    const res = await axios.get(`/leave-request/${id}`).then(getData)
    return res.data[0]
  })

export const usePostNewLeaveRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (postData) => {
      const res = await axios.post(`/leave-request`, postData)
      return res
    },
    {
      onSuccess: () => {
        // invalidate and refetch
        queryClient.invalidateQueries('leave-request')
        queryClient.invalidateQueries('entitlement')
        queryClient.invalidateQueries('big-calendar')
        queryClient.invalidateQueries('disabled-date')
      },
    }
  )
}

export const usePostNewLeaveCreditRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (postData) => {
      const res = await axios.post(`/leave-request`, postData)
      return res
    },
    {
      onSuccess: () => {
        // invalidate and refetch
        queryClient.invalidateQueries(['leave-request', { type: 3 }])
        queryClient.invalidateQueries('entitlement')
      },
    }
  )
}

// This query is to withdraw leave request
export const useDeleteLeaveRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (requestId) => {
      const res = await axios.delete(`/leave-request/${requestId}`)
      return res
    },
    {
      onSuccess: (data, requestId) => {
        // invalidate and refetch
        queryClient.invalidateQueries('leave-request')
        queryClient.invalidateQueries(['leave-request', String(requestId)])
        queryClient.invalidateQueries('entitlement')
        queryClient.invalidateQueries('big-calendar')
        queryClient.invalidateQueries('disabled-date')
        queryClient.invalidateQueries('DashboardRequest')
      },
    }
  )
}
export const useDeleteLeaveCreditRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (requestId) => {
      const res = await axios.delete(`/leave-request/${requestId}`)
      return res
    },
    {
      onSuccess: (data, requestId) => {
        // invalidate and refetch
        queryClient.invalidateQueries('leave-request')
        queryClient.invalidateQueries(['leave-request', { type: 3 }])
        queryClient.invalidateQueries('entitlement')
      },
    }
  )
}

export const usePutUploadLeaveCreditAttachment = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ id, postData }) => {
      const res = await axios.put(`/leave-request/${id}`, postData)
      return res
    },
    {
      onSuccess: (data, { id }) => {
        queryClient.invalidateQueries(['leave-request', { type: 3 }])
        queryClient.invalidateQueries(['leave-request', String(id)])
      },
    }
  )
}
